import type { IMCSSearchColumnConfig } from '@ups/xplat/features';
import type { DropDownSearchExtensionDirective } from './dropdowns-search.ex-directive';

/** The event search-ex emits on a filter change; moved out of the directive file (US 31663, file-size gate). */
export class SeFilterChangeExArgs {
  public target: DropDownSearchExtensionDirective;
  public query: string;
  extension: any;

  constructor(
    searchExDirective: DropDownSearchExtensionDirective,
    query: string,
    searchIndex: number = undefined
  ) {
    this.target = searchExDirective;
    this.query = query;
    this.extension = {
      searchIndex: searchIndex,

      target: this.target,
      query: this.query,

      getColumnFilterSettings: () => this.target.getColumnFilterSettings(),
      toStateEx: (
        search: string,
        take: number = undefined,
        createForKendoToOdataString = true,
        columnFilterSettings: IMCSSearchColumnConfig[] = undefined
      ) =>
        this.target.toStateEx(
          search,
          take,
          createForKendoToOdataString,
          columnFilterSettings
        ),
      toODataQuery: (
        search: string,
        take: number = undefined,
        additionalODataFilterExpression: string = undefined,
        columnFilterSettings: IMCSSearchColumnConfig[] = undefined
      ): string =>
        this.target.toODataQuery(
          search,
          take,
          additionalODataFilterExpression,
          columnFilterSettings
        ),
      process: (
        allData: any[],
        search: string,
        columnFilterSettings: IMCSSearchColumnConfig[] = undefined
      ) => this.target.process(allData, search, columnFilterSettings),
      applyData: (
        data: any[],
        dataCountTotal: number = undefined,
        take: number = undefined
      ) =>
        this.target.applyData(
          data,
          dataCountTotal,
          take,
          this.extension.searchIndex
        ),
    };
  }
}
